import React from "react";
// import Button from '../Button'
import { Button } from "react-bootstrap";
import { StyledDiv } from "./Section5.style";
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom';
interface Section5Props {
  handleMenuItemClick: (menuItemKey?: any) => void;
}
const Section5: React.FC<Section5Props> = ({ handleMenuItemClick }) => {
  const history = useHistory();
  const handleFindOutMore=(menuItem:any)=>
    {
    history.push('/myindici-for-providers')
    window.scrollTo(0, 0);
    handleMenuItemClick(menuItem);
  }
 
  return (
    <StyledDiv>
      <div className="container text-center modrenHealth">
        <div className="row">
          <div className="col-md-12">
            <h2 className="myindici-heading2 mb-2">
              Modern Healthcare for Providers
            </h2>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <p className="benefitsmyindici2 mb-4">
              The benefits of the myindici patient portal extend to medical
              practices just as much as to patients. Myindici supports a
              productive and meaningful patient engagement framework,
              complementing in-person services with powerful virtual tools and
              care channels.
            </p>
            <Button className="pl-2 pr-2 find-out text-white btn btn-primary"
            onClick={() =>handleFindOutMore("MyIndici for Providers")}>Find Out More</Button>
          </div>
        </div>
      </div>
    </StyledDiv>
  );
};
export default Section5;